
import {Icon, TooltipHost} from '@fluentui/react';
import React, { Component } from 'react'


export default class InfoTooltip extends Component {
    // constructor(props) {
    //     super(props);

    //     // this.handleLoad = this.handleLoad.bind(this)
    // }

    // handleLoad()
    // {
    //     console.log("loaded");
    // }

    // componentDidMount() {
    //     console.log('InfoTooltip');
    //     console.log(this.props.content);
    // }
  
    render() {  
        return (
            <div style={tooltipStyles}>
                <TooltipHost onLoad = {() => this.handleLoad()} content={this.props.content} closeDelay={500} >
                    <Icon style={iconStyles} iconName='info' />
                </TooltipHost>
            </div>
        )
    }
}


const tooltipStyles = {
    verticalAlign: 'middle',
    display: 'inline',
    marginLeft: '5px',
    cursor: 'pointer'
};

const iconStyles = {
    //marginLeft: '5px'
}



// WEBPACK FOOTER //
// ./src/components/formFields/InfoTooltip.js